import { UserService } from '~/app-modules/user/services/user.service';
import { PermissionType } from '~/app-modules/user-access-right/clients/enums/permission-type';

export interface CheckSatisfyPermissionsResult {
  notSatisfiedPermissions: PermissionType[];
  hasAuth: boolean;
}

@singleton()
export class AccessControlService {
  constructor(private readonly userService: UserService) {}

  async checkSatisfyPermissions(
    requiredPermissions: PermissionType[],
  ): Promise<CheckSatisfyPermissionsResult> {
    const currentUser = await this.userService.ensureCurrentUser();
    if (!currentUser)
      return {
        notSatisfiedPermissions: [],
        hasAuth: false,
      };

    return {
      notSatisfiedPermissions: requiredPermissions.filter(
        (p) => !currentUser!.permissions.includes(p),
      ),
      hasAuth: true,
    };
  }

  isPermissionsSatisfy(requiredPermissions: PermissionType[]): boolean {
    const currentUser = this.userService.currentUser;

    if (!currentUser) return false;

    return requiredPermissions.every((p) => currentUser!.permissions.includes(p));
  }
}
